<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item flex-row">
        <b-link
          class="navbar-brand ml-2"
          to="/home">
          <img :src="Logo"/>
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  data() {
    return {
      Logo: require('@/assets/images/logo/Subsidios.svg'),
    }
  },
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
}
</script>

<style lang="scss">
img {
  width: 50%;
}
</style>
